import "./SignIn.style.css";

// React
import { useState } from "react";

// React Bootstrap
import { Button, Container, Form, InputGroup, FloatingLabel, Spinner } from "react-bootstrap";

// React Bootstrap Icons
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";

// Sweet Alert 2
import Swal from "sweetalert2";

// Axios
import axios from "axios";

// React Router Dom
import { useNavigate } from "react-router-dom";

const SignIn = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [usernameValue, setUsernameValue] = useState("");
    const [passwordValue, setPasswordValue] = useState("");

    const handleSignIn = async (e) => {
        e.preventDefault();

        if (isLoading) return 1;

        if (usernameValue === "" || usernameValue.length === 0 || usernameValue === null || usernameValue === undefined) {
            return Swal.fire({
                title: "Oops!",
                text: "Username is required!",
                icon: "error"
            });
        } else if (passwordValue === "" || passwordValue.length === 0 || passwordValue === null || passwordValue === undefined) {
            return Swal.fire({
                title: "Oops!",
                text: "Password is required!",
                icon: "error"
            });
        }

        setIsLoading(true);

        const formData = new FormData();
        formData.append("username", usernameValue);
        formData.append("password", passwordValue);

        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/user/sign-in`, formData).then((res) => {
            setIsLoading(false);

            localStorage.setItem("userData", JSON.stringify(res.data.data));
            localStorage.setItem("accessToken", res.data.accessToken);

            navigate("/business/dashboard");
        }).catch((err) => {
            setIsLoading(false);

            if (err?.response?.status === 422) {
                return Swal.fire({
                    title: "Oops!",
                    text: err?.response?.data?.errors?.username || err?.response?.data?.errors?.password,
                    icon: "error"
                });
            } else if (err?.response?.status === 401) {
                return Swal.fire({
                    title: "Oops!",
                    text: err?.response?.data?.message,
                    icon: "error"
                });
            } else {
                console.error(err);

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    return (
        <section id="sign-in" className="sign-in">
            <Container>
                <div className="sign-in-box">
                    <div className="left-box">
                        <h1>Aulia Printing</h1>
                        <p>Percetakan | Service Komputer / Laptop & Printer | Fotocopy & ATK</p>
                    </div>
                    <form method="POST" onSubmit={handleSignIn} className="right-box">
                        <h1>Sign In</h1>
                        <div className="username-wrapper">
                            <FloatingLabel label="Username">
                                <Form.Control type="text" placeholder="Username" onChange={(e) => setUsernameValue(e.target.value)} />
                            </FloatingLabel>
                        </div>
                        <div className="password-wrapper">
                            <FloatingLabel label="Password">
                                <Form.Control type={showPassword ? "text" : "password"} placeholder="Password" onChange={(e) => setPasswordValue(e.target.value)} />
                                <InputGroup.Text onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeFill /> : <EyeSlashFill />}</InputGroup.Text>
                            </FloatingLabel>
                        </div>
                        <Button type="submit" disabled={isLoading}>{isLoading ? <Spinner size="sm" /> : "Sign In"}</Button>
                    </form>
                </div>
            </Container>
        </section>
    );
}

export default SignIn;